import {MouseEvent, PropsWithChildren} from "react";

import {usePingPongOverflowText} from "./use_ping_pong_overflow_text";

import * as styles from "./PingPongOverflowText.module.css";

interface IProps extends PropsWithChildren {
    className?: string;
    enabled?: boolean;
}

const hasTextSelection = () => {
    const selection = window.getSelection();

    return Boolean(selection && !selection.isCollapsed && selection.toString());
};

const stopParentClickWhenSelecting = (event: MouseEvent<HTMLDivElement>) => {
    if (hasTextSelection()) {
        event.stopPropagation();
    }
};

export const PingPongOverflowText = (props: IProps) => {
    const {children, className, enabled = true} = props;
    const {containerRef, contentRef, showEllipsis} = usePingPongOverflowText({enabled});

    if (!enabled) {
        return children;
    }

    return (
        <div className={[styles.container, className].filter(Boolean).join(" ")} onClick={stopParentClickWhenSelecting} ref={containerRef}>
            <div className={showEllipsis ? styles.ellipsisInner : styles.movingInner} ref={contentRef}>
                {children}
            </div>
        </div>
    );
};
import {MouseEvent, PropsWithChildren} from "react";

import {usePingPongOverflowText} from "./use_ping_pong_overflow_text";

import * as styles from "./PingPongOverflowText.module.css";

interface IProps extends PropsWithChildren {
    className?: string;
    enabled?: boolean;
}

const hasTextSelection = () => {
    const selection = window.getSelection();

    return Boolean(selection && !selection.isCollapsed && selection.toString());
};

const stopParentClickWhenSelecting = (event: MouseEvent<HTMLDivElement>) => {
    if (hasTextSelection()) {
        event.stopPropagation();
    }
};

export const PingPongOverflowText = (props: IProps) => {
    const {children, className, enabled = true} = props;
    const {containerRef, contentRef, showEllipsis} = usePingPongOverflowText({enabled});

    if (!enabled) {
        return children;
    }

    return (
        <div className={[styles.container, className].filter(Boolean).join(" ")} onClick={stopParentClickWhenSelecting} ref={containerRef}>
            <div className={showEllipsis ? styles.ellipsisInner : styles.movingInner} ref={contentRef}>
                {children}
            </div>
        </div>
    );
};
